import { render, staticRenderFns } from "./EventsHistory.html?vue&type=template&id=6bb80410&scoped=true&external"
import script from "./EventsHistory.js?vue&type=script&lang=js&external"
export * from "./EventsHistory.js?vue&type=script&lang=js&external"
import style0 from "./EventsHistory.scss?vue&type=style&index=0&id=6bb80410&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb80410",
  null
  
)

export default component.exports